/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetRankingProducts200ResponseAllOfData } from './GetRankingProducts200ResponseAllOfData';
import {
    GetRankingProducts200ResponseAllOfDataFromJSON,
    GetRankingProducts200ResponseAllOfDataFromJSONTyped,
    GetRankingProducts200ResponseAllOfDataToJSON,
} from './GetRankingProducts200ResponseAllOfData';
import type { ResponseSuccessWithPagingAllOfMeta } from './ResponseSuccessWithPagingAllOfMeta';
import {
    ResponseSuccessWithPagingAllOfMetaFromJSON,
    ResponseSuccessWithPagingAllOfMetaFromJSONTyped,
    ResponseSuccessWithPagingAllOfMetaToJSON,
} from './ResponseSuccessWithPagingAllOfMeta';

/**
 * 
 * @export
 * @interface GetRankingProducts200Response
 */
export interface GetRankingProducts200Response {
    /**
     * 
     * @type {GetRankingProducts200ResponseAllOfData}
     * @memberof GetRankingProducts200Response
     */
    data: GetRankingProducts200ResponseAllOfData;
    /**
     * 
     * @type {ResponseSuccessWithPagingAllOfMeta}
     * @memberof GetRankingProducts200Response
     */
    meta: ResponseSuccessWithPagingAllOfMeta;
}

/**
 * Check if a given object implements the GetRankingProducts200Response interface.
 */
export function instanceOfGetRankingProducts200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetRankingProducts200ResponseFromJSON(json: any): GetRankingProducts200Response {
    return GetRankingProducts200ResponseFromJSONTyped(json, false);
}

export function GetRankingProducts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRankingProducts200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetRankingProducts200ResponseAllOfDataFromJSON(json['data']),
        'meta': ResponseSuccessWithPagingAllOfMetaFromJSON(json['meta']),
    };
}

export function GetRankingProducts200ResponseToJSON(value?: GetRankingProducts200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetRankingProducts200ResponseAllOfDataToJSON(value.data),
        'meta': ResponseSuccessWithPagingAllOfMetaToJSON(value.meta),
    };
}

